/* RAGANA — Theme JS */

document.addEventListener('DOMContentLoaded', function() {

  // ===== HEADER SCROLL =====
  const header = document.querySelector('.header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  // ===== CART DRAWER =====
  const cartDrawer = document.getElementById('ragana-cart-drawer');
  const cartOverlay = document.getElementById('ragana-cart-overlay');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.style.display = 'block';
    document.body.style.overflow = 'hidden';
    fetch('/cart.js').then(r => r.json()).then(updateCartDrawer);
  }

  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.style.display = 'none';
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-open-cart]').forEach(btn => btn.addEventListener('click', openCart));
  document.querySelectorAll('[data-close-cart]').forEach(btn => btn.addEventListener('click', closeCart));
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function updateCartDrawer(cart) {
    const countEl = document.querySelectorAll('[data-cart-count]');
    countEl.forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
    const itemsEl = document.getElementById('ragana-cart-items');
    const totalEl = document.getElementById('ragana-cart-total');
    if (itemsEl) {
      if (cart.items.length === 0) {
        itemsEl.innerHTML = '<p style="font-family:var(--font-body);font-size:.9rem;color:var(--ragana-stone);font-style:italic;text-align:center;padding:2rem 0">Votre panier est vide.</p>';
      } else {
        itemsEl.innerHTML = cart.items.map(item => `
          <div style="display:flex;gap:1rem;padding:1rem 0;border-bottom:1px solid var(--ragana-cream-dark)">
            <img src="${item.image || ''}" alt="${item.product_title}" style="width:72px;height:90px;object-fit:cover;background:var(--ragana-cream)">
            <div style="flex:1">
              <p style="font-family:var(--font-heading);font-size:.9rem;margin-bottom:.25rem">${item.product_title}</p>
              <p style="font-family:var(--font-ui);font-size:.72rem;color:var(--ragana-stone);letter-spacing:.08em;margin-bottom:.5rem">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>
              <div style="display:flex;justify-content:space-between;align-items:center">
                <div style="display:flex;align-items:center;gap:.5rem">
                  <button onclick="raganaUpdateCart('${item.key}', ${item.quantity - 1})" style="background:none;border:1px solid var(--ragana-cream-dark);width:28px;height:28px;cursor:pointer;font-family:var(--font-ui)">-</button>
                  <span style="font-family:var(--font-ui);font-size:.85rem;min-width:20px;text-align:center">${item.quantity}</span>
                  <button onclick="raganaUpdateCart('${item.key}', ${item.quantity + 1})" style="background:none;border:1px solid var(--ragana-cream-dark);width:28px;height:28px;cursor:pointer;font-family:var(--font-ui)">+</button>
                </div>
                <span style="font-family:var(--font-ui);font-size:.9rem;font-weight:500">${(item.final_line_price / 100).toFixed(0)} USD</span>
              </div>
            </div>
          </div>
        `).join('');
      }
    }
    if (totalEl && cart.items.length > 0) {
      totalEl.textContent = (cart.total_price / 100).toFixed(0) + ' USD';
    }
  }

  window.raganaUpdateCart = function(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(r => r.json()).then(updateCartDrawer);
  };

  // ===== ADD TO CART =====
  document.querySelectorAll('[data-add-to-cart]').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const data = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: data.get('id'), quantity: 1 })
      }).then(r => r.json()).then(() => {
        fetch('/cart.js').then(r => r.json()).then(cart => {
          updateCartDrawer(cart);
          openCart();
        });
      });
    });
  });

  // ===== SIZE SELECTOR =====
  document.querySelectorAll('.ragana-product__size-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const group = this.closest('.ragana-product__sizes');
      if (group) group.querySelectorAll('.ragana-product__size-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      const variantInput = document.querySelector('[name="id"]');
      if (variantInput) variantInput.value = this.dataset.variantId || '';
    });
  });

  // ===== FADE-IN ON SCROLL =====
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.animationPlayState = 'running';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.ragana-animate').forEach(el => {
    el.style.animationPlayState = 'paused';
    observer.observe(el);
  });

  // ===== INIT CART COUNT =====
  fetch('/cart.js').then(r => r.json()).then(updateCartDrawer);

});